import { render, staticRenderFns } from "./PayrollCardHeader.vue?vue&type=template&id=084562c0&scoped=true"
import script from "./PayrollCardHeader.vue?vue&type=script&lang=ts"
export * from "./PayrollCardHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084562c0",
  null
  
)

export default component.exports